export default "__VITE_ASSET__ybm14xWw__"